//  [BD feat] Collection tab links js :- https://prnt.sc/xamlyNGO01bb
//  [BD feat] Collection tab links js :- https://prnt.sc/xamlyNGO01bb
(function() {
  'use strict';
  document.addEventListener('DOMContentLoaded', function() {
    const collectionBlock = document.querySelector('.collection_block_link');
    if (!collectionBlock) return;
    collectionBlock.addEventListener('click', function(event) {
      const clickedLink = event.target.closest('a');
      if (!clickedLink) return;
      document.querySelectorAll('.collection_block_link a.active')
             .forEach(el => el.classList.remove('active'));
      clickedLink.classList.add('active');
      clickedLink.focus();
    });
    collectionBlock.addEventListener('keydown', function(event) {
      if (['Enter', ' '].includes(event.key)) {
        event.target.click();
      }
    });
  });
})();




// [BD feat] mega menu js start here :- https://prnt.sc/LIY1QRPyCo4Ds
(function() {
  'use strict';
  document.addEventListener("DOMContentLoaded", function () {
  // Select all hover menu elements
  const menuContainers = document.querySelectorAll('.hover_menu_cmt');

  menuContainers.forEach(function (hoverArea) {
    const trigger = hoverArea.querySelector('a');
    const menu = hoverArea.querySelector('.mega-menu__linklist');

    if (trigger && menu) {
      // Set cursor to pointer for the <a> tag
      trigger.style.cursor = "pointer";

      // Initially hide the menu
      menu.style.display = "none";

      // Add click event listener to <a> tag containing <svg>
      trigger.addEventListener("click", function (e) {
        e.preventDefault();  // Prevent default behavior (e.g., following the link)

        // Toggle menu visibility
        if (menu.style.display === "none" || menu.style.display === "") {
          menu.style.display = "block";
        } else {
          menu.style.display = "none";
        }

        // Optionally: Do something with the <svg> when clicked
        const svg = trigger.querySelector('svg');
        if (svg) {
          console.log('SVG clicked');
          // Rotate the SVG on click
          svg.style.transition = 'transform 0.3s ease'; // Smooth transition for rotation
          svg.style.transform = svg.style.transform === 'rotate(91deg)' ? 'rotate(0deg)' : 'rotate(91deg)';
        }
      });

      // Hide the menu when mouse leaves the hover area
      hoverArea.addEventListener("mouseleave", function () {
        menu.style.display = "none"; // Hide menu on mouse leave

        // Reset the SVG rotation to 0deg
        const svg = trigger.querySelector('svg');
        if (svg) {
          svg.style.transform = 'rotate(0deg)'; // Reset the SVG rotation
        }
      });

      // Optional: Click outside to close the menu
      document.addEventListener("click", function (e) {
        if (!hoverArea.contains(e.target)) {
          menu.style.display = "none"; // Hide the menu if clicked outside
        }
      });
    }
  });
});
})();





// [BD feat]  accordian js start here
(function() {
  'use strict';
  document.addEventListener('DOMContentLoaded', setupExclusiveAccordions);
document.addEventListener('shopify:section:load', setupExclusiveAccordions); // Theme editor

function setupExclusiveAccordions(e) {
  const root = e?.target || document;
  const disclosures = root.querySelectorAll('accordion-disclosure');

  disclosures.forEach((disclosure, index) => {
    const summary = disclosure.querySelector('summary');
    const details = disclosure.querySelector('details');
    if (!summary || !details || disclosure._accordionInit) return;

    summary.addEventListener('click', () => {
      setTimeout(() => {
        disclosures.forEach(other => {
          if (other !== disclosure) {
            const otherDetails = other.querySelector('details');
            if (otherDetails && otherDetails.open) {
              otherDetails.removeAttribute('open'); // Close it
            }
          }
        });
      }, 0);
    });

    disclosure._accordionInit = true;

    // ✅ Open the first accordion by default
    if (index === 0 && !details.open) {
      setTimeout(() => {
        details.setAttribute('open', ''); // Open it
      }, 50);
    }
  });
}
})();


// [BD feat] pdp  accordian js start here (for all accordian) :-   https://prnt.sc/XOdEVgzA3yEO
(function() {
  'use strict';
  document.addEventListener('DOMContentLoaded', () => {
    const accordionItems = document.querySelectorAll('.custom-accordion .bd-accordion_main');

    accordionItems.forEach(item => {
      const header = item.querySelector('.bd-accordion_main .header_accordion');
      const content = item.querySelector('.bd-accordion_main .accordion_content');

      header.addEventListener('click', () => {
        const isActive = item.classList.contains('active');

        // Close all other accordion items
        accordionItems.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.classList.remove('active');
            otherItem.querySelector('.bd-accordion_main .accordion_content').style.height = '0';
            otherItem.querySelector('.bd-accordion_main .header_accordion').setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle current item
        if (isActive) {
          item.classList.remove('active');
          content.style.height = '0';
          header.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('active');
          content.style.height = 'auto'; // Auto height based on content
          header.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
})();





// [BD feat] sub collection banner on home page :-  https://prnt.sc/yikJitMhmxjR
(function() {
  'use strict';
 var swiper = new Swiper(".sub_collection_banner .mySwiper", {
    slidesPerView:1.3,
    spaceBetween:0,
    loop: true,
    pagination: {

      dynamicBullets: false,
      clickable: true,
    },
    breakpoints: {
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
      1440: { slidesPerView: 4 }
    }
  });
})();



// [BD feat]  Unsere smaints Markenbotschafter  js start here :- https://prnt.sc/Bk-ldLfRaMVK
(function() {
  'use strict';
  var swiper2 = new Swiper('.unsere_smaints_sec', {
    slidesPerView: 1.05,
    spaceBetween: 16,
    freeMode: true,
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    breakpoints: {
        // when window width is <= 499px
        499: {
            slidesPerView: 1.05,
            spaceBetween: 16
        },
        1024:{
          slidesPerView: 1.7,
        },
        1280:{
          slidesPerView: 1.7,
        },
        1300:{
          slidesPerView: 1.7,
        },
        1440: {
            slidesPerView: 1.7,
            spaceBetween: 16
        }
    }
});
})();



// [BD feat]  feature tab  js :- https://prnt.sc/6jRjbiL1qqZg
(function() {
  'use strict';
  document.addEventListener("DOMContentLoaded", () => {
    // Safely get last URL segment
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    if (pathSegments.length === 0) return; // Exit if no segments
    
    const lastSegment = pathSegments[pathSegments.length - 1].toLowerCase();
    const tabButtons = document.querySelectorAll('featured-collections-tabs button[role="tab"]');

    tabButtons.forEach(btn => {
      // Add safety check for dataset.handle
      if (btn.dataset.handle && btn.dataset.handle.toLowerCase() === lastSegment) {
        btn.click();
      }
    });
  });
})();








// [BD feat]  wir-sind-smaints js start here :- https://prnt.sc/NgglIplw5CsU
(function() {
  'use strict';
  var swiper = new Swiper('.mySwiper.wir-sind-smaints', {
    slidesPerView:  1.3,
    spaceBetween: 10,
    loop: true,
    breakpoints: {
      // when window width is >= 640px
      480: {
        slidesPerView: 1.3,
        spaceBetween: 20,
      },
      // when window width is >= 768px
      768: {
        slidesPerView: 2.1,
        spaceBetween: 30,
      },
      // when window width is >= 1024px
      1024: {
        slidesPerView: 3.1,
        spaceBetween: 40,
      },
    },
  });
})();




// [BD feat]  About Page Accordion js start here :-  https://prnt.sc/BNrZR32AKDK5
(function() {
  'use strict';
     document.addEventListener("DOMContentLoaded", function () {
  const headers = document.querySelectorAll(".rte_column_wraper .accordion-header");

  // CLOSE ALL ACCORDIONS BY DEFAULT
  const allItems = document.querySelectorAll(".rte_column_wraper .accordion-item");
  allItems.forEach(item => {
    item.classList.remove("active");
    const content = item.querySelector(".accordion-content");
    if (content) content.style.display = "none";
  });

  headers.forEach(header => {
    header.addEventListener("click", function () {
      const currentItem = this.parentElement;
      const allItems = document.querySelectorAll(".rte_column_wraper .accordion-item");

      allItems.forEach(item => {
        if (item !== currentItem) {
          item.classList.remove("active");
          const content = item.querySelector(".accordion-content");
          if (content) content.style.display = "none";
        }
      });

      const content = currentItem.querySelector(".accordion-content");
      const isOpen = currentItem.classList.contains("active");

      if (isOpen) {
        content.style.display = "none";
        currentItem.classList.remove("active");
      } else {
        content.style.display = "block";
        currentItem.classList.add("active");
      }
    });
  });
});
})();




// [BD feat]  Influncer product with  image js :- https://prnt.sc/bbxzABG22hY9
(function() {
  'use strict';
  document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".product_image_slider .slider-products-wrapper.swiper", {
      slidesPerView:1,
      loop:true,
      spaceBetween:0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
        scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 3,
        }
      }
    });
  });
})();







//  [BD feat]  scroll-to-top.js  :- https://prnt.sc/tfNyGVDIOhK0
(function() {
  'use strict';


  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }


  if (typeof window.scrollToTop === 'undefined') {
    window.scrollToTop = scrollToTop;
  } else {
    console.warn('window.scrollToTop पहले से मौजूद है!');
  }
})();




//  [BD feat]  modal.js Inhaltsstoffe :-  https://prnt.sc/EZEVL8nsrEhJ

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    const modalWrapper = document.querySelector(".main-inhaltsstoffe-modal");
    const modal = modalWrapper?.querySelector("#customModal");
    const openModalBtn = document.getElementById("openModal");
    const closeModalBtn = modalWrapper?.querySelector(".close-modal");

    // Early exit if elements not found
    if (!openModalBtn || !modal || !closeModalBtn) {
      console.warn('Modal elements missing!');
      return;
    }

    // Open modal function
    function openModal(event) {
      event.preventDefault();
      modal.style.display = "block";
      document.body.style.overflow = 'hidden';
      modal.setAttribute('aria-hidden', 'false');
    }

    // Close modal function
    function closeModal() {
      modal.style.display = "none";
      document.body.style.overflow = '';
      modal.setAttribute('aria-hidden', 'true');
    }

    // Event listeners
    openModalBtn.addEventListener("click", openModal);
    closeModalBtn.addEventListener("click", closeModal);

    // Close when clicking outside
    window.addEventListener("click", function(event) {
      if (event.target === modal) {
        closeModal();
      }
    });

    // Close with Escape key
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && modal.style.display === 'block') {
        closeModal();
      }
    });

    // Accessibility: Focus trap (optional)
    modal.addEventListener('keydown', function(e) {
      if (e.key === 'Tab') {
        // Implement focus trap logic here
      }
    });
  });
})();

// [BD feat] Toggle variant price state from .spare_im_subscription radios (fixed)
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initSubscriptionPriceToggle(document);
  });

  // Theme editor: init alleen binnen de herladen sectie
  document.addEventListener('shopify:section:load', function (e) {
    initSubscriptionPriceToggle(e && e.target);
  });

  function initSubscriptionPriceToggle(rootOrEvent) {
    // Gebruik document als rootOrEvent geen Node/Element is
    const scopeRoot =
      rootOrEvent && typeof rootOrEvent.querySelectorAll === 'function'
        ? rootOrEvent
        : document;

    const wrappers = scopeRoot.querySelectorAll('.spare_im_subscription');
    if (!wrappers.length) return;

    wrappers.forEach((wrapper) => {
      if (wrapper._subscriptionToggleInit) {
        // Re-sync state bij herinitialisatie
        updateState(wrapper);
        return;
      }

      wrapper._subscriptionToggleInit = true;

      // Event delegation voor radio’s binnen deze wrapper
      wrapper.addEventListener('change', function (evt) {
        const target = evt.target;
        if (target && target.matches('input[name="radio-group"][type="radio"]')) {
          updateState(wrapper);
        }
      });

      // Initieel syncen
      updateState(wrapper);
    });
  }

  function updateState(wrapper) {
    const checked = wrapper.querySelector('input[name="radio-group"]:checked');
    const val =
      (checked && (checked.dataset.value || checked.getAttribute('data-value'))) ||
      '';
    const isSub = val.toLowerCase().trim() === 'abonnement';

    // Scope: eerst dichtstbijzijnde product-gebied, anders document
    const localProductScope =
      wrapper.closest('.choose_an_offer_pdp_page') ||
      wrapper.closest('.product, .product-section, .product__info-wrapper, .page-width') ||
      document;

    localProductScope
      .querySelectorAll('.price_display_container')
      .forEach((el) => {
        el.classList.toggle('show_selling_plan_price', isSub);
      });
  }
})();



// [BD feat] Mobile menu js
(function() {
  document.addEventListener("DOMContentLoaded", function () {
    const menuContainer = document.querySelector(".secondry_menu");
    if (!menuContainer) return;

    const triggers = menuContainer.querySelectorAll(".accordion-trigger");

    triggers.forEach(trigger => {
      trigger.addEventListener("click", function (e) {
        e.preventDefault();

        const submenu = this.nextElementSibling;
        if (!submenu) return;

        // Close all other submenus inside this container only
        menuContainer.querySelectorAll(".sub_menu_data").forEach(ul => {
          if (ul !== submenu) {
            ul.style.display = "none";
            ul.previousElementSibling?.classList.remove("active");
          }
        });

        // Toggle current submenu
        submenu.style.display = submenu.style.display === "block" ? "none" : "block";

        // Toggle arrow rotation (class on <a>)
        this.classList.toggle("active", submenu.style.display === "block");
      });
    });
  });
})();



// [BD feat] Megamenu scroll behaviour issues resolve
(function () {
  const menu = document.querySelector("#header-menu-dropdown-1");

  if (menu) {
    // MutationObserver to detect attribute changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "open") {
          if (menu.hasAttribute("open")) {
            document.body.classList.add("activemenu");   // ✅ add class
          } else {
            document.body.classList.remove("activemenu"); // ❌ remove class
          }
        }
      });
    });

    observer.observe(menu, {
      attributes: true // only watch attribute changes
    });
  }
})();

// [BD feat] remove if a is empty
(function() {
  
  const links = document.querySelectorAll('.home-banner_collection ul li a');

  links.forEach(link => {

    if (!link.textContent.trim()) {
      link.style.display = 'none';             
      link.parentElement.classList.add('empty-link'); 
    }
  });
})();
